import { AUTHORITY_ROLES } from '@mentora/shared-components'
import { z } from 'zod'

export const emailField = z.string().trim().toLowerCase().email()
export const orgNameField = z.string().trim().min(3).max(80)
export const categoryNameField = z.string().trim().min(1).max(80)
export const urlField = z.string().trim().url()
export const passwordField = z.string().min(8)

// Opaque entity ids (member/invitation/organization/category ids). External
// callers can tamper with these, so parse them rather than trusting truthiness.
export const idField = z.string().trim().min(1)
// Authority role enum — derived from the shared source of truth, never hardcoded.
export const authorityRoleField = z.enum(AUTHORITY_ROLES)
export const booleanField = z.boolean()
// One segment of a path the action revalidates (a slug or id taken from the
// client). A '/' would let the caller name any page on the site, so refuse it.
export const pathSegmentField = z.string().min(1).max(200).refine(value => !value.includes('/'))
